import React, { useState, useEffect } from "react";
import { ComparisionViewButton, ChartWrapper, MainWrapper } from "../MetricDashboard.styles";
import { Loader } from "@vds/loaders";
import * as caseSupportCreatedVSClosed from "../../../api/metricDashboard/SupportCreatedVSClosed";
import { Chart } from "primereact/chart";
import ChartDataLabels from "chartjs-plugin-datalabels";
import Colors from "../../MetricDashboard/VCCPButtons/Colors";
import CPNotification from "../../Login/CPNotification";
import { Wrapper } from "../../../constants/common/StyledGlobalConstants";
import PropTypes from "prop-types";

const CreatedVSClosed = ({ chartFilterValue, regionFilterValue, selectFromToDates, refreshBtn }) => {
  const [chartData, setChartData] = useState({});
  const [createVSClosedData, setCreateVSClosedData] = useState([]);
  const [options, setOptions] = useState({});
  const [isChartShow, setIsChartShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState();

  useEffect(() => {
   const shouldFetch = 
     (selectFromToDates.startDate === "" && selectFromToDates.endDate === "") || 
     refreshBtn;
  
    if (shouldFetch) {
      getSupportCreatedVSClosed();
    }
  }, [chartFilterValue, regionFilterValue, selectFromToDates, refreshBtn]);
  const getSupportCreatedVSClosed = async () => {
    setIsLoading(true);
    let responseArray = [];
    let reqBody;
    try {
      if (selectFromToDates.startDate !== "" && selectFromToDates.endDate !== "") {
        reqBody = {
          fromDate: selectFromToDates.startDate,
          toDate: selectFromToDates.endDate,
          region: regionFilterValue,
        };
      } else {
        reqBody = {
          filter: chartFilterValue,
          region: regionFilterValue,
        };
      }

      responseArray = await caseSupportCreatedVSClosed.getCaseSupportCreatedVSClosed(reqBody);
      setIsLoading(false);
      if (responseArray.data.statusCode === "200") {
        if (responseArray.data.data.statusCountList.length !== 0) {
          setCreateVSClosedData(responseArray.data.data.statusCountList);
          let data = responseArray.data.data.statusCountList;
          const chartData = {
            labels: data.map((el) => el.date),
            datasets: data[0].statusList.map((el, index) => {
              return {
                label: el.status,
                backgroundColor: Colors[index],
                borderColor: Colors[index],
                data: data.map((el) => el.statusList[index].count),
              };
            }),
          };
          setChartData(chartData);
          const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
              legend: {
                labels: {
                  fontColor: "lightgray",
                },
              },
              datalabels: {
                display: true,
                color: "black",
                font: {
                  size: 12,
                  weight: "bold",
                },
              },
            },
            scales: {
              x: {
                ticks: {
                  color: "brown",
                  font: {
                    weight: 500,
                  },
                },
                grid: {
                  display: false,
                  drawBorder: false,
                },
              },
              y: {
                ticks: {
                  color: "brown",
                },
                grid: {
                  color: "lightgray",
                  drawBorder: false,
                },
              },
            },
          };

          setOptions(options);
          setIsLoading(false);
        } else {
          setCreateVSClosedData(responseArray.data.data.statusCountList);
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
        notify("Unable to fetch data due to an unexpected error", "error", true);
      }
    } catch (err) {
      console.log("error", err);
      setIsLoading(false);
      notify("Unable to fetch data due to an unexpected error", "error", true);
    }
    return responseArray;
  };

  const onErrorNotificationClose = () => {
    setNotification(null);
  };

  const notify = (content, type, show) => {
    setNotification(
      <CPNotification isOpen={show} notificationType={type} height="auto" width="90%" closeButton={true} onClose={() => onErrorNotificationClose()}>
        <Wrapper fontFamily="neue-haas-grotesk-text" fontSize="0.875rem">
          {content}
        </Wrapper>
      </CPNotification>
    );
    setTimeout(() => {
      setNotification(null);
    }, 5000);
  };

  const buttonHandle = () => {
    setIsChartShow(!isChartShow);
  };

  return (
    <MainWrapper>
      <div style={{ marginBottom: "20px", marginLeft: "10px" }}>{notification}</div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <ComparisionViewButton isChartShow={isChartShow} onClick={() => buttonHandle()}>
          Created Vs Closed
        </ComparisionViewButton>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {isChartShow && (
          <ChartWrapper>
            <div style={{ position: "relative", width: "1.5rem", height: "1.5rem", left: "50%" }} aria-label="loader overlay">
              <Loader active={isLoading} fullscreen={false} />
            </div>
            {createVSClosedData.length !== 0 ? (
              <Chart type="bar" data={chartData} options={options} width="600px" height="350px" plugins={[ChartDataLabels]} />
            ) : (
              "No Data Available"
            )}
          </ChartWrapper>
        )}
      </div>
    </MainWrapper>
  );
};

CreatedVSClosed.propTypes = {
  chartFilterValue: PropTypes.any.isRequired,
  regionFilterValue: PropTypes.any.isRequired,
  selectFromToDates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }).isRequired,
  refreshBtn: PropTypes.bool.isRequired,
};

export default CreatedVSClosed;